// src/modules/financials/routes.jsx
import { Routes, Route } from 'react-router-dom';
import FinancialDashboardPage from './pages/FinancialDashboardPage';

const FinancialRoutes = () => (
  <Routes>
    <Route path="/" element={<FinancialDashboardPage />} />
  </Routes>
);

export default FinancialRoutes;
